import { rankingItems } from '@/mocks/home';

const trendIcons: Record<string, string> = {
  up: 'ri-arrow-up-line',
  hot: 'ri-fire-line',
  new: 'ri-star-line',
};

const trendColors: Record<string, string> = {
  up: 'text-accent-600 bg-accent-100',
  hot: 'text-red-500 bg-red-50',
  new: 'text-primary-600 bg-primary-100',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center gap-3">
            <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900">热度榜单</h2>
          </div>
          <span className="text-xs text-foreground-400">每日更新</span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="group flex items-center gap-4 p-4 md:p-5 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="relative flex-shrink-0">
                <span
                  className={`w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-xl text-lg md:text-xl font-black ${
                    item.rank <= 3
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-200 text-foreground-500'
                  }`}
                >
                  {item.rank}
                </span>
                {item.rank <= 3 && (
                  <span className="absolute -top-1 -right-1 w-5 h-5 flex items-center justify-center bg-accent-500 text-background-50 rounded-full text-[10px]">
                    <i className="ri-star-fill"></i>
                  </span>
                )}
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
                  {item.title}
                </h3>
                <div className="flex items-center gap-2 mt-1.5">
                  <span className="text-xs text-foreground-400 bg-background-100 px-2 py-0.5 rounded-full">
                    {item.category}
                  </span>
                  <span className="text-xs font-semibold text-foreground-600">
                    {item.score}分
                  </span>
                </div>
              </div>

              <div className="flex flex-col items-end gap-1 flex-shrink-0">
                <span className={`inline-flex items-center gap-0.5 text-xs font-medium px-2 py-0.5 rounded-full ${trendColors[item.trend]}`}>
                  <i className={`${trendIcons[item.trend]} text-[10px]`}></i>
                  {item.trend === 'up' ? '上升' : item.trend === 'hot' ? '热门' : '新上榜'}
                </span>
                <span className="text-xs text-foreground-400 whitespace-nowrap">{item.views}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}